import { connectHook } from 'app/common/components/connect-hook';
import { NumberWidget } from './number-widget.js';
import { useNumberWidget } from './number-widget-hook.js';

export default connectHook(NumberWidget, useNumberWidget);
